var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-4693.5 5703 27.5 16.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #005195;\n      }\n\n      .cls-4 {\n        fill: #e49603;\n      }\n\n      .cls-5 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "cls-1",
    d: "M0-183.487H27.5v16.907H0Z",
    transform: "translate(0 183.487)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(-4693.5 5703.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    className: "cls-2",
    d: "M.4-166.138H27.862V-183H.4Z",
    transform: "translate(-0.367 183.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    className: "cls-3",
    d: "M0-179H27.5v-4.491H0Z",
    transform: "translate(0 183.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    className: "cls-4",
    d: "M0-44.249H27.5V-48.74H0Z",
    transform: "translate(0 61.155)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "group-2",
    "data-name": "group",
    className: "cls-5",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-3",
    "data-name": "group",
    transform: "translate(4.74 5.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    "data-name": "path",
    className: "cls-3",
    d: "M0-1.835v-.186l2.828.054L2.879,2,5.207-1.941l1.4,0L2.882,4.242H1.3S1.212,1.087,1.166-.467C1.127-1.787.52-1.672,0-1.835",
    transform: "translate(0 2.021)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-4",
    "data-name": "group",
    transform: "translate(9.897 5.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    "data-name": "path",
    className: "cls-3",
    d: "M0-61.445H1.608l2.011-6.236H2.026Z",
    transform: "translate(0 67.681)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-5",
    "data-name": "group",
    transform: "translate(12.732 5.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    "data-name": "path",
    className: "cls-3",
    d: "M-50.009-15.334a3.7,3.7,0,0,0-1.322-.53c-.3,0-.844.272-.844.743,0,.982,1.807.937,1.807,2.534,0,.749-.415,2.17-2.617,2.17a2.92,2.92,0,0,1-2.1-.652l.514-.934a2.835,2.835,0,0,0,1.537.476c.657,0,1.085-.257,1.085-.65,0-.8-1.959-1.143-1.959-2.531a2.4,2.4,0,0,1,2.617-2.182,2.481,2.481,0,0,1,1.9.752Z",
    transform: "translate(55.085 16.89)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group-6",
    "data-name": "group",
    transform: "translate(17.315 5.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-8",
    "data-name": "path",
    className: "cls-3",
    d: "M-35.927-16.975l.185,2.214H-37.09Zm1.506-1.723h-1.8l-3.357,6.182h1.434l.629-1.242h1.819l0,1.242h1.534Z",
    transform: "translate(39.573 18.698)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisa);
export default __webpack_public_path__ + "static/media/icon-visa.9e57e61ed1202f9f4b24a1e2e568ccc4.svg";
export { ForwardRef as ReactComponent };